<template>
    <div class="AboutUs">
        <RouteHeadAndCrumbs
            :backgroundImg="backgroundImg"
            :breadcrumbsInfo="breadcrumbsInfo"
        />
        <AboutAsComponent />
        <div
            class="corporate-culture-container"
            :style="`background:url(${corporateCultureBgImg}) no-repeat;background-size: cover;`"
        >
            <div class="corporate-culture-shade" />
            <div class="corporate-culture-main-container">
                <p class="title-text">企业文化</p>
                <p class="title-sub-text">伦伟企业文化</p>
                <div class="corporate-culture-content">
                    <div class="left-menu-container">
                        <div
                            @click="changeActiveType('idea')"
                            :class="`one-menu-item-container${
                                activeType === 'idea' ? ' is-active' : ''
                            }`"
                        >
                            <p>我们的理念</p>
                            <img
                                class="grey-img"
                                src="../assets/images/idea-grey.png"
                                alt=""
                            />
                            <img
                                class="white-img"
                                src="../assets/images/idea-white.png"
                                alt=""
                            />
                        </div>
                        <div
                            @click="changeActiveType('server')"
                            :class="`one-menu-item-container${
                                activeType !== 'idea' ? ' is-active' : ''
                            }`"
                        >
                            <p>我们的服务</p>
                            <img
                                class="grey-img"
                                src="../assets/images/service-grey.png"
                                alt=""
                            />
                            <img
                                class="white-img"
                                src="../assets/images/service-white.png"
                                alt=""
                            />
                        </div>
                    </div>
                    <div
                        v-html="
                            activeType === 'idea'
                                ? aboutUsInfo.companyIdea
                                : aboutUsInfo.companyService
                        "
                        class="right-content-container"
                    ></div>
                </div>
            </div>
        </div>
        <div class="honorary-support-container">
            <p class="title-text">
                <span>荣誉</span>
                <span class="blue-text">资质</span>
            </p>
            <p class="title-sub-text">我们的荣誉</p>
            <div class="honorary-main-container">
                <template v-if="qualificationInfo.length >= 1">
                    <div class="one-honorary-row">
                        <div class="one-honorary-img-container">
                            <el-image
                                class="certificate-img"
                                :src="qualificationInfo[0].imgUrl"
                                :preview-src-list="new Array(qualificationInfo[0].imgUrl)"
                            ></el-image>
                            <div class="medal-img-container">
                                <img
                                    class="medal-img"
                                    src="../assets/images/medal.png"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div class="one-honorary-desc-container">
                            <p>{{ qualificationInfo[0].title }}</p>
                            <p>获得时间：{{ qualificationInfo[0].time }}</p>
                            <p>{{ qualificationInfo[0].description }}</p>
                        </div>
                    </div>
                </template>
                <template v-if="qualificationInfo.length >= 2">
                    <div class="one-honorary-row middle-honorary-row">
                        <div class="one-honorary-img-container">
                            <el-image
                                class="certificate-img"
                                :src="qualificationInfo[1].imgUrl"
                                :preview-src-list="new Array(qualificationInfo[1].imgUrl)"
                            ></el-image>
                            <div class="medal-img-container">
                                <img
                                    class="medal-img"
                                    src="../assets/images/medal.png"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div class="one-honorary-desc-container">
                            <p>{{ qualificationInfo[1].title }}</p>
                            <p>获得时间：{{ qualificationInfo[1].time }}</p>
                            <p>{{ qualificationInfo[1].description }}</p>
                        </div>
                    </div>
                </template>

                <div class="one-honorary-row bottom-honorary-row">
                    <div class="last-other-info">
                        <div class="other-text-container">
                            <span class="other-text">Honorary certificate</span>
                        </div>
                        <div class="arrow-container">
                            <div
                                @click="changePage(-1)"
                                class="one-arrow-container is-large"
                            >
                                <i class="el-icon-arrow-left"></i>
                            </div>
                            <div
                                @click="changePage(1)"
                                class="one-arrow-container"
                            >
                                <i class="el-icon-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                    <template v-if="qualificationInfo.length >= 3">
                        <div class="one-honorary-desc-container">
                            <p>{{ qualificationInfo[2].title }}</p>
                            <p>获得时间：{{ qualificationInfo[2].time }}</p>
                            <p>{{ qualificationInfo[2].description }}</p>
                        </div>
                        <div class="one-honorary-img-container">
                            <el-image
                                class="certificate-img"
                                :src="qualificationInfo[2].imgUrl"
                                :preview-src-list="new Array(qualificationInfo[2].imgUrl)"
                            ></el-image>
                            <div class="medal-img-container">
                                <img
                                    class="medal-img"
                                    src="../assets/images/medal.png"
                                    alt=""
                                />
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <ContactInfo />
    </div>
</template>

<script>
import headImg from "../assets/images/about.png";

import { ROUTEINFO } from "../utils/constant";

import corporateCultureBgImg from "../assets/images/joinUs.png";

import { GETABOUTUSINFO, GETPICTUREINFO } from "../utils/uriList";

export default {
    mounted() {
        this.getAountUsInfo();
        this.getQualificationInfo();
    },
    components: {
        AboutAsComponent: () => import("../components/Home/AboutUs"),
        ContactInfo: () => import("../components/Home/ContactInfo"),
    },
    data() {
        return {
            backgroundImg: headImg,
            breadcrumbsInfo: [
                {
                    routeName: ROUTEINFO.home.name,
                    routeLabel: "首页",
                    routeTo: {
                        path: ROUTEINFO.home.path,
                    },
                },
                {
                    routeName: ROUTEINFO.aboutUs.name,
                    routeLabel: "关于我们",
                },
            ],
            corporateCultureBgImg,
            aboutUsInfo: {},
            activeType: "idea",
            qualificationInfo: [],
            pageNum: 1,
            originalqualificationInfoList: [],
        };
    },
    methods: {
        async getAountUsInfo() {
            const response = await this.$http.get(GETABOUTUSINFO);
            if (response.data.code === 0) {
                this.aboutUsInfo = response.data.data;
            }
        },
        async getQualificationInfo() {
            const response = await this.$http.get(GETPICTUREINFO, {
                params: {
                    type: 3,
                },
            });
            if (response.data.code === 0) {
                this.originalqualificationInfoList = response.data.data;
                this.formatQualificationInfoList();
            }
        },
        changeActiveType(activeType) {
            this.activeType = activeType;
        },
        formatQualificationInfoList() {
            const list = [...this.originalqualificationInfoList];
            this.qualificationInfo = list.slice(
                (this.pageNum - 1) * 3,
                this.pageNum * 3
            );
        },
        changePage(num) {
            if (
                this.pageNum + num > 0 &&
                this.pageNum + num <=
                    (this.originalqualificationInfoList.length + 1) / 3
            ) {
                this.pageNum += num;
                this.formatQualificationInfoList();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/views/AboutUs.scss";
</style>
